import React, {useState} from 'react'
import { createRoot } from 'react-dom/client';
import axios from 'axios'
import Comment from './comment'
import { debounce } from 'lodash';
import ellaUserData from '../../../../../src/es6/ella_account'

function Comments() {
    const [results, setResults] = useState([])
    const [comment, setComment] = useState('')
    const [userAuthorized, setUserAuthorized] = useState(false)
    const [userLoggedIn, setUserLoggedIn] = useState(false)
    const csrftoken = getCookie('csrftoken');
    const [serverMessage, setServerMessage] = useState('')
    const textAreaMaxLength = 1000
    const [charsLeft, setChartsLeft] = useState(textAreaMaxLength)

    const setCookie = () => {
        let referrer = `${window.location.href.replace(/\/+$/, '')}`
        document.cookie = `POC_LOCAL_REDIRECT=${referrer};max-age=3600;path=/`
        window.location.href = "/accounts/ellaprovider/login/?process=login"
    }

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    const limitTextarea = (comment) => {
        const charCount = comment.length;
        setChartsLeft(textAreaMaxLength - charCount)
    }

    const changedText = comment_value => {
        limitTextarea(comment_value)
    }

    const delayedQuery = debounce(comment_value => changedText(comment_value), 100);

    const onChange = e => {
        setComment(e.target.value)
        delayedQuery(e.target.value);
    };

    const postCommentClick = async event => {
        try {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrftoken
                },
                body: JSON.stringify({
                    "parent": 0,
                    "comment": comment,
                    "article": article_id
                })
            }
            const response = await fetch('/comments/post', config)
            if (response.ok) {
                const new_comment = await response.json()
                new_comment.scroll_animation = true
                setResults([new_comment, ...results])
                setComment('')
            } else {
                //
            }
        } catch (error) {
            //
        }
    }


    React.useEffect(() => {
        async function fetchComments() {
            let articleid = article_id
            const result = await axios(
                '/comments/get/'+article_id
            )
            setResults([...results, ...result.data])
        }

        async function canComment() {
            let user_data = await ellaUserData
            try {
                setUserAuthorized(user_data.permissions.access_web)
                setUserLoggedIn(user_data.authenticated)
            } catch (error) {
                setUserAuthorized(false)
                setUserLoggedIn(false)
            }
        }

        fetchComments()
        canComment()
    }, []);

    const listItems = results.map((item, index) => {
        return (<Comment key={index} comment={item} level={1} userAuthorized={userAuthorized} userLoggedIn={userLoggedIn} csrftoken={csrftoken}/>)
    })

    return (
        <div className={`materializecss`}>
            { userAuthorized &&
            <>
                <textarea className="comment-textarea"
                          rows="4"
                          cols="50"
                          value={comment}
                          onChange={onChange}
                          type="text"
                          placeholder="Dodaj komentar ..."
                          maxLength={textAreaMaxLength}></textarea>
                <span className="comment_chars_left">Na voljo imate še {charsLeft} znakov.</span>
                <button className="btn waves-effect waves-light tags__btn" onClick={() => postCommentClick()}>
                    POŠLJI
                </button>
                <div className="clear"></div>
            </>
            }
            {(!userAuthorized || !userLoggedIn) &&
            <div>
                <a href={'/novice/slovenija/komentiranje-na-delo-si-na-voljo-le-se-narocnikom/'}
                   className={`not-authorized-text`}
                   target={`_blank`}>Komentirajo lahko le prijavljeni uporabniki z aktivno naročnino.</a>
                {!userLoggedIn &&
                    <div className="btn waves-effect waves-light tags__btn socialaccount_provider ellaprovider"
                       onClick={() => setCookie()}>
                        PRIJAVA
                    </div>
                }
            </div>
            }
            <div className={'list_comments'}>
                {results.length > 0 &&
                <>{listItems}</>
                }
            </div>
        </div>
    );
}

window.addEventListener('load', function () {
    let element = document.getElementById("comments")
    element ? createRoot(element).render(<Comments/>) : ''
});